<script setup>
import { mdiClose } from "@mdi/js";
import { computed , defineProps ,defineEmits} from "vue";
import CardComponent from "./CardComponent.vue";

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  largeTitle: {
    type: String,
    default: null,
  },
  button: {
    type: String,
    default: "info",
  },
  buttonLabel: {
    type: String,
    default: "Done",
  },
  icon: {
    type: String,
    default: mdiClose,
  },
  type: {
    type: String,
    default: null,
  },
  width: {
    type: String,
    default: null,
  },
  hasCancel: Boolean,
  modelValue: {
    type: [String, Number, Boolean],
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "cancel", "confirm"]);

const componentClass = computed(() => {
  const base = [];
  if (props.type === 'fixed') {
    base.push(
      `shadow-none w-full max-h-max md:${props.width} lg:${props.width} z-50 dark:text-slate-200 overflow-y-auto`
    );
  }
  base.push(`shadow-none w-full max-h-modal md:${props.width} lg:${props.width} z-50 dark:text-slate-200 overflow-y-auto`)
  return base;
});
const value = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const confirmCancel = (mode) => {
  value.value = false;
  emit(mode);
};

const cancel = () => confirmCancel("cancel");
</script>

<template>
  <base-overlay v-if="icon" v-show="value" @overlay-click="cancel">
    <card-component v-if="width" v-show="value" :title="title" :class="componentClass" :header-icon="icon"
      @headerIconClicked="cancel">
      <div class="space-y-3">
        <h1 v-if="largeTitle" class="text-2xl">{{ largeTitle }}</h1>
        <slot />
      </div>
    </card-component>
    <card-component v-else v-show="value" :title="title" :class="type === 'fixed' ? 'shadow-none w-full max-h-max md:w-3/5 lg:w-2/5 z-50 dark:text-slate-200 overflow-y-auto' :
      'shadow-none w-full max-h-modal md:w-3/5 lg:w-2/5 z-50 dark:text-slate-200 overflow-y-auto'" :header-icon="icon"
      @headerIconClicked="cancel">
      <div class="space-y-3">
        <h1 v-if="largeTitle" class="text-2xl">{{ largeTitle }}</h1>
        <slot />
      </div>
    </card-component>
  </base-overlay>
  <base-overlay v-else v-show="value">
    <card-component v-show="value" :title="title" header-icon="" :class="type === 'fixed' ? 'shadow-none w-full max-h-max md:w-2/5 lg:w-5/12 z-50 overflow-y-auto' :
      'shadow-none w-full max-h-modal md:w-2/5 lg:w-5/12 z-50 overflow-y-auto'">
      <div class="space-y-3">
        <h1 v-if="largeTitle" class="text-2xl">{{ largeTitle }}</h1>
        <slot />
      </div>
    </card-component>
  </base-overlay>
</template>
